export default __webpack_public_path__ + "static/media/frg--community-cafe.cf781889.png";